import React from 'react';
import { StatusTypes } from '@chegg/commerce-utils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import NotificationBanner from '../NotificationBanner/NotificationBanner';
import { NotificationTypes } from '@chegg-ui/notification-banner';
import { NotificationBannerWrapper } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
var MessageBox = function MessageBox() {
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var _ref = config.ui,
    displayServerErrors = _ref.displayServerErrors;
  var message = payment.message,
    formFields = payment.formFields;
  if (!displayServerErrors) return null;
  var formFieldsWithStringAsKeys = formFields;
  var displayMessage = '';
  var text = message.text,
    type = message.type;
  var errors = Object.keys(formFieldsWithStringAsKeys).filter(function (k) {
    return formFieldsWithStringAsKeys[k].error.length;
  }).map(function (k) {
    return formFieldsWithStringAsKeys[k].error;
  });
  var classname = type === StatusTypes.EMPTY ? 'visually-hidden' : '';
  if (type === StatusTypes.ERROR) {
    displayMessage = text;
  } else if (errors.length > 0) {
    displayMessage = errors.join(' ');
  }
  if (!displayMessage) return null;
  return /*#__PURE__*/React.createElement(NotificationBannerWrapper, {
    role: 'alert',
    "data-test": DataTestAttributes.MESSAGE_BOX,
    "aria-live": 'polite'
  }, /*#__PURE__*/React.createElement(NotificationBanner, {
    bannerType: NotificationTypes.Error,
    message: displayMessage,
    className: classname
  }));
};
export default MessageBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MessageBox/MessageBox.js
// module id = 894
// module chunks = 11